import React from "react";
import dayjs from "dayjs";

const RenderDate = ({ date, colourise = false }) => {
    let display = "Not specified";
    let warning = false;

    if (!!date) {
        display = new Date(date).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
        if (colourise && dayjs().isAfter(date, "day")) {
            warning = true;
        }
    }

    return <span className={warning ? "error" : ""}>{display}</span>;
};

export default React.memo(RenderDate);
